import fitvids from 'fitvids';
import { throttle } from './common/waHelpers';
import '../sass/theme.scss'; // load in styles

const weba = {};

window.$ = window.jQuery;

const $document = $(document);

/*--------------
    Main Menu
------------------ */

weba.mainMenu = {
    init() {
        const $hamburgerMenuBtn = $('#js-open-nav');
        const $navMenu = $('#nav-menu-container');
        const $menuLinks = $navMenu.find('a');
        const $brandingLink = $('.site__branding__title-link');

        $hamburgerMenuBtn.on('click', () => {
            const isOpen = $hamburgerMenuBtn.attr('aria-expanded') === 'true';
            if (!isOpen) {
                // Open the menu
                $navMenu.attr('aria-hidden', 'false').addClass('visible');
                $hamburgerMenuBtn.attr('aria-expanded', 'true');
                $menuLinks.attr('tabindex', '0');
                $('body').addClass('mobile__menu--open');
            } else {
                // Close the menu
                $navMenu.attr('aria-hidden', 'true').removeClass('visible');
                $hamburgerMenuBtn.attr('aria-expanded', 'false');
                $menuLinks.attr('tabindex', '-1');
                $('body').removeClass('mobile__menu--open');
            }
        });

        // Enhanced focus management for wrapping focus within the menu
        $(document).on('keydown', (e) => {
            if (e.key === 'Tab' && $hamburgerMenuBtn.attr('aria-expanded') === 'true') {
                e.preventDefault();
                const focusableElements = [
                    $brandingLink[0],
                    $hamburgerMenuBtn[0],
                    ...$menuLinks.toArray(),
                ];
                const currentIndex = focusableElements.indexOf(document.activeElement);
                const isShiftPressed = e.shiftKey;
                let nextIndex = currentIndex + (isShiftPressed ? -1 : 1);

                // Wrap focus if necessary
                if (nextIndex >= focusableElements.length) {
                    nextIndex = 0;
                } else if (nextIndex < 0) {
                    nextIndex = focusableElements.length - 1;
                }

                focusableElements[nextIndex].focus();
            }
        });

        $hamburgerMenuBtn.on('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                $hamburgerMenuBtn.trigger('click');
            }
        });

        // Ensure the navigation adapts on window resize
        $(window).on('resize', throttle(() => {
            if ($(window).width() >= 768) {
                $navMenu.attr('aria-hidden', 'true').removeClass('visible').addClass('visually-hidden');
                $hamburgerMenuBtn.attr('aria-expanded', 'false');
                $('body').removeClass('mobile__menu--open');
            }
        }, 250));
    },
    toggleOpen(element, className) {
        if (element.classList.contains(className)) {
            element.classList.remove(className);
        } else {
            element.classList.add(className);
        }
    },

    // Activate Submenu
    activateSubMenu(event) {
        const clickedElement = event.target;
        const thisDropdown = clickedElement.nextElementSibling;
        if (event.type === 'mousedown') {
            // alert('Mouse interaction!');
        } else if (event.type === 'touchstart') {
            event.preventDefault();
            if (clickedElement.classList.contains('dropdown-toggle--toggled')) {
                if (clickedElement.getAttribute('href')) {
                    window.location.href = clickedElement.getAttribute('href');
                }
            }
        }
        weba.mainMenu.toggleOpen(clickedElement, 'dropdown-toggle--toggled');
        weba.mainMenu.toggleOpen(thisDropdown, 'dropdown-menu--open');
    },
    navbarToggleHandler(event) {
        event.preventDefault();
        const toggle = $(this);
        const body = $document.find('body');
        const headerNavigation = $document.find('.primary__navigation');
        if (!body.hasClass('mobile__menu--open')) {
            // Open the menu
            body.addClass('mobile__menu--open');
            toggle.addClass('menu__trigger--close');
            headerNavigation.addClass('open');
        } else {
            // Close the menu
            body.removeClass('mobile__menu--open');
            toggle.removeClass('menu__trigger--close');
            headerNavigation.removeClass('open');
        }
    },
    // Handle Mobile Menu Functionality
    expandMobileMenu() {
        $document.find('.header__navbar--toggle-button').on('click', weba.mainMenu.navbarToggleHandler);
        $('.menu-item-has-children.dropdown').each(function dropdownHandler() {
            // $(this).find('.dropdown-toggle').on('click', weba.mainMenu.activateSubMenu);
            $(this).find('.dropdown-toggle').on('mousedown touchstart', weba.mainMenu.activateSubMenu);
        });
    },
}; // weba.mainMenu

/* ----------------------------------------
  Helper Functions - Interactive Blocks
------------------------------------------ */

/*----------------------
    Flexible Content - Interactive Blocks
------------------------ */
weba.theme = {
    init() {
        weba.theme.initResponsiveVideo();
        weba.theme.initAccordion();
    },
    initResponsiveVideo() {
        const videoWrapper = $('.video__embed__container');
        if (videoWrapper.length > 0) {
            fitvids(videoWrapper);
        }
    },
    initAccordion() {
        const itijAccordions = document.querySelectorAll('.accordion__items');
        itijAccordions.forEach((itijAccordion) => {
            $(itijAccordion).accordion({
                header: '.accordion__header__wrapper',
                active: false,
                animate: 300,
                collapsible: true,
                heightStyle: 'content',
            });
        });
    },
};

// Init when page ready
const $window = $(window);
$window.on('DOMContentLoaded', () => {
    weba.mainMenu.init(); // Main Menu.
    weba.theme.init(); // Theme functionality
});
